module.exports = __webpack_public_path__ + "img/monster-12.24c393a6.png";